import './index.css';
import './App.css';
import React, { useState, useEffect } from 'react';

const translateText = async (text, targetLang) => {
  const url = 'https://deep-translate1.p.rapidapi.com/language/translate/v2';

  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'X-RapidAPI-Key': 'e843ea22bdmsh70d85a8cf545ce9p1f4ee1jsn61dceb2d05fa',
      'X-RapidAPI-Host': 'deep-translate1.p.rapidapi.com'
    },
    // e843ea22bdmsh70d85a8cf545ce9p1f4ee1jsn61dceb2d05fa
    body: JSON.stringify({
      q: text,
      source: 'en',
      target: targetLang
    })
  };

  try {
    const response = await fetch(url, options);
    const result = await response.json();
    return result.data.translations.translatedText;
  } catch (error) {
    console.error('Translation Error:', error);
    return "Error occurred!";
  }
};

const Header = () => {
  return (
    <div style={{ background: 'grey', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
      <h1 className="text-3xl font-bold underline text-center"> Text Translator App </h1>
    </div>

  )
}

const SearchBar = ({ value, onChange }) => (
  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
    <input
      type="text"
      value={value}
      onChange={onChange}
      placeholder="Enter your english sentence, word, or phrase here"
      style={{ padding: '15px', width: '300px', marginTop: '50px' }}
    />
  </div>
);

const Button = ({ onClick }) => (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
    <button onClick={onClick} style={{ padding: '10px 20px', fontSize: '10px' }}>
      Translate
    </button>
  </div>

);


const Output = ({ text }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      marginTop: '50px'
    }}
  >
    <div
      style={{
        width: '600px',
        minHeight: '80px',
        padding: '20px',
        background: '#f5f5f5',
        border: '1px solid #ccc',
        borderRadius: '8px',
        fontSize: '1.2rem',
        textAlign: 'center'
      }}
    >
      {text}
    </div>
  </div>
);

const LanguageSelector = ({ value, onChange }) => (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
    <select value={value} onChange={onChange} style={{ padding: '10px', width: '200px' }}>
      <option value="fr">French</option>
      <option value="es">Spanish</option>
      <option value="ru">Russian</option>
      <option value="de">German</option>
      <option value="hi">Hindi</option>
      <option value="ko">Korean</option>
    </select>
  </div>
);



function App() {
  const [inputText, setInputText] = useState('');
  const [selectedLang, setSelectedLang] = useState('fr');
  const [outputText, setOutputText] = useState('');
  const [darkMode, setDarkMode] = useState(false);
  
  const handleTranslate = async () => {
    const result = await translateText(inputText, selectedLang);
    setOutputText(result);
  };
  
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);


  return (

    <div className="min-h-screen p-4 bg-white text-black dark:bg-gray-900 dark:text-white">
      {/* Dark Mode Toggle Button */}
      <div className="flex justify-end">
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="mb-4 px-4 py-2 bg-gray-200 dark:bg-gray-800 text-sm rounded"
        >
          Toggle Dark Mode
        </button>
      </div>

      {/* Existing App Content */}
      <div className="text-2xl font-bold text-blue-500 dark:text-blue-300">
        <Header />
        <SearchBar
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
        />
        <LanguageSelector
          value={selectedLang}
          onChange={(e) => setSelectedLang(e.target.value)}
        />
        <button
          onClick={() =>
            setSelectedLang(selectedLang === 'hi' ? 'en' : 'hi')
          }
          className="ml-2 bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600 px-2 py-1 rounded"
        >
          Swap
        </button>

        <Button onClick={handleTranslate} />
        <Output text={outputText} />
        <button
          onClick={() => navigator.clipboard.writeText(outputText)}
          className="mt-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
        >
          Copy Translation
        </button>
      </div>
    </div>
  );
}

export default App;
